import { config } from "./config";
import axios from "axios";
import { createAPIError, handleAxiosError } from "./utils/error.utils";
import { UnexpectedAPIError } from "./errors";
function isRole(role) {
    return role.hasOwnProperty("id") && role.hasOwnProperty("name");
}
export const users = (() => {
    async function create(user) {
        try {
            const response = await axios.post(baseUrl(), user);
            if (response.status === 201)
                return response.data;
            else
                throw response.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function retrieve(idOrUser) {
        if (idOrUser && typeof idOrUser !== "number") {
            idOrUser = idOrUser.id;
        }
        if (typeof idOrUser === "number") {
            try {
                const url = `${baseUrl()}/${idOrUser}`;
                const response = await axios.get(url);
                if (response.status === 200)
                    return response.data;
                else
                    throw response.data;
            }
            catch (error) {
                if (error.response)
                    handleAxiosError(error.response);
                else
                    throw UnexpectedAPIError;
            }
        }
        throw [
            createAPIError("incorrect_data", "please provide an id, or a (user) object with id"),
        ];
    }
    async function queryUsers(query) {
        const params = {
            ...query,
            role: query.role
                ? query.role.map((role) => (isRole(role) ? role.name : role))
                : undefined,
            sort: query.sort
                ? query.sort.map((sorting) => `${sorting.field}|${sorting.direction}`)
                : undefined,
            enabled: query.enabled === "any" ? undefined : query.enabled,
        };
        const requestConfig = {
            params: params,
            paramsSerializer: (params) => {
                const parsed = new URLSearchParams(params);
                const cleanUp = [];
                parsed.forEach((value, key) => {
                    if (["undefined", undefined].indexOf(value) > -1) {
                        cleanUp.push(key);
                    }
                });
                cleanUp.forEach((key) => parsed.delete(key));
                return parsed.toString();
            },
        };
        try {
            const response = await axios.get(baseUrl(), requestConfig);
            if (response.status === 200)
                return response.data;
            else
                throw response.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function update(user) {
        const userId = user && user.id ? user.id : undefined;
        const { password, id, email, ...requestBody } = { ...user }; // prepare request body
        if (!userId) {
            throw [
                createAPIError("incorrect_data", "please provide a (user) object with id"),
            ];
        }
        try {
            const url = `${baseUrl()}/${userId}`;
            const response = await axios.put(url, requestBody);
            if (response.status === 200)
                return response.data;
            else
                throw response.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function remove(idOrUser) {
        if (typeof idOrUser !== "number") {
            idOrUser = idOrUser.id;
        }
        if (typeof idOrUser === "number") {
            try {
                const url = `${baseUrl()}/${idOrUser}`;
                const response = await axios.delete(url);
                if (response.status === 200)
                    return;
                else
                    throw response.status;
            }
            catch (error) {
                if (error.response)
                    handleAxiosError(error.response);
                else
                    throw UnexpectedAPIError;
            }
        }
        else {
            throw [
                createAPIError("incorrect_data", "please provide an id, or a (user) object with id"),
            ];
        }
    }
    function baseUrl() {
        return `${config.fullUrl()}/users`;
    }
    return {
        create: create,
        get: retrieve,
        query: queryUsers,
        update: update,
        delete: remove,
    };
})();
